// feature/role-views — Histórico de fallos. All fallos that have left the
// `fallo_pendiente_revision` state — Molly can browse her past decisions.
import React, { useEffect, useMemo, useState } from "react";
import { cases as casesApi } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import CaseDetail from "../case-detail";
import { TIPO_FALLO_OPTS } from "./Fallos";
import { ESTADO_LABEL } from "../../components/Pills";

const fmt = (d) => d ? new Date(d).toLocaleString("es-CO") : "—";

const DECISION_OPTS = [
  ["",            "Todas"],
  ["impugnado",   "Impugnado"],
  ["no_impugnado","No impugnado"],
];

const HIST_STATES = new Set([
  "fallo_decidido_impugnar","fallo_decidido_no_impugnar",
  "pendiente_insumos","insumos_solicitados","expediente_solicitado","insumos_recibidos",
  "en_elaboracion","en_auditoria","con_observaciones","aprobado","en_litisoft","cerrado",
]);

export default function FallosHistoric() {
  const [tipoFallo, setTipoFallo] = useState("");
  const [decision,  setDecision]  = useState("");
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);

  function load() {
    setData(null);
    casesApi.list({ tipo: "fallo" })
      .then(r => setData(r.data.filter(c => HIST_STATES.has(c.estado))))
      .catch(() => setData([]));
  }
  useEffect(() => { load(); }, []);

  // Decision pill: derived from estado.
  const visible = useMemo(() => {
    if (!data) return [];
    return data.filter(c => {
      if (decision === "impugnado"    && c.estado !== "fallo_decidido_impugnar"
          && !["pendiente_insumos","insumos_solicitados","expediente_solicitado","insumos_recibidos","en_elaboracion","en_auditoria","con_observaciones","aprobado","en_litisoft","cerrado"].includes(c.estado))
        return false;
      if (decision === "no_impugnado" && c.estado !== "fallo_decidido_no_impugnar" && c.estado !== "cerrado")
        return false;
      // tipo_fallo lives on case_type_data, not the list response — ignore filter here
      return true;
    });
  }, [data, decision, tipoFallo]);

  return (
    <div className="col" style={{ gap: 16 }}>
      <h1 style={{ margin: 0 }}>Histórico de fallos</h1>
      <div className="muted" style={{ marginTop: -8 }}>
        Decisiones tomadas previamente. Solo lectura.
      </div>

      <div className="card tight" style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <div style={{ flex: "0 0 200px" }}>
          <label>Tipo de fallo</label>
          <select value={tipoFallo} onChange={(e) => setTipoFallo(e.target.value)}>
            {TIPO_FALLO_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        <div style={{ flex: "0 0 200px" }}>
          <label>Decisión</label>
          <select value={decision} onChange={(e) => setDecision(e.target.value)}>
            {DECISION_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        <div style={{ flex: 1 }} />
        <span className="muted" style={{ fontSize: 12 }}>{data == null ? "" : `${visible.length} fallo(s)`}</span>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !visible.length ? (
          <Empty title="Sin decisiones registradas" />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Accionante</th><th>Radicado</th>
                <th>Juzgado</th><th>Decisión</th><th>Estado actual</th><th>Fecha de decisión</th>
              </tr>
            </thead>
            <tbody>
              {visible.map(c => {
                const impugnado = c.estado === "fallo_decidido_impugnar"
                  || ["pendiente_insumos","insumos_solicitados","expediente_solicitado","insumos_recibidos","en_elaboracion","en_auditoria","con_observaciones","aprobado","en_litisoft"].includes(c.estado);
                return (
                  <tr key={c.id} onClick={() => setOpenId(c.id)} style={{ cursor: "pointer" }}>
                    <td><strong>{c.case_number}</strong></td>
                    <td>{c.accionante_nombre || "—"}</td>
                    <td>{c.radicado}</td>
                    <td>{c.juzgado || "—"}</td>
                    <td>
                      <span className={"badge " + (impugnado ? "mint" : "muted")}>
                        {impugnado ? "Impugnado" : "No impugnado"}
                      </span>
                    </td>
                    <td><span className="muted">{ESTADO_LABEL[c.estado] || c.estado}</span></td>
                    <td>{fmt(c.updated_at)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <CaseDetail
        caseId={openId} open={!!openId}
        defaultTab="decision"
        onClose={() => setOpenId(null)}
        onChanged={load}
      />
    </div>
  );
}
